/* eslint-disable import/prefer-default-export */
export const Colors = {
  correct: '#3B8B43',
  acceptable: '#f76916',
  wrong: 'red',
  dismissed: 'grey.200',
  reviewed: 'royalblue',
};
